import { createBooleanLocalStorageState } from './manager';

export const showLongBreaksGlobalState = createBooleanLocalStorageState('showLongBreaks', true);
